<template>
  <div class="stream-config">
    <b-row>
      <b-col md="6">
        <b-card>
          <b-card-header>
            <h5 class="mb-0">
              <feather-icon icon="SettingsIcon" class="mr-2" />
              Configuração da Transmissão
            </h5>
          </b-card-header>
          
          <b-card-body>
            <b-form @submit.prevent="saveConfig">
              <!-- Campos da Stream -->
              <h6 class="text-primary mb-3">
                <feather-icon icon="VideoIcon" class="mr-1" />
                Dados da Transmissão
              </h6>
              
              <b-form-group label="Título da Transmissão:">
                <b-form-input
                  v-model="config.title"
                  placeholder="Digite o título da sua transmissão"
                  required
                />
              </b-form-group>
              
              <b-form-group label="Descrição:">
                <b-form-textarea
                  v-model="config.description"
                  placeholder="Descrição da transmissão (opcional)"
                  rows="3"
                />
              </b-form-group>
              
              <!-- <b-form-group label="Data e Hora de Início:">
                <b-form-input
                  v-model="config.scheduledStartTime"
                  type="datetime-local"
                />
                <small class="text-muted">
                  Data e hora para início da transmissão
                </small>
              </b-form-group> -->
              
              <!-- <b-form-group label="Privacidade:">
                <b-form-select
                  v-model="config.privacy"
                  :options="privacyOptions"
                />
              </b-form-group> -->
              
              <!-- <b-form-group label="Thumbnail (opcional):">
                <b-form-file
                  v-model="config.thumbnailFile"
                  accept="image/*"
                  placeholder="Selecione uma imagem para thumbnail"
                  drop-placeholder="Arraste uma imagem aqui..."
                />
                <small class="text-muted">
                  Formatos suportados: JPG, PNG, GIF (máximo 2MB)
                </small>
              </b-form-group> -->
              
              <hr class="my-4">
              
              <h6 class="text-primary mb-3">
                <feather-icon icon="SettingsIcon" class="mr-1" />
                Configurações Técnicas
              </h6>
              
              <b-form-group label="Stream Key do YouTube:">
                <b-form-input
                  v-model="config.streamKey"
                  placeholder="Cole sua Stream Key do YouTube Studio"
                  required
                />
                <small class="text-muted">
                  Encontre sua Stream Key em: YouTube Studio > Configurações > Stream
                </small>
              </b-form-group>

              <b-form-group label="Arquivo de Vídeo:">
                <!-- Vídeo já enviado - versão simplificada -->
                <div v-if="config.videoUrl && !showChangeVideo" class="uploaded-video-card">
                  <div class="d-flex align-items-center justify-content-between p-3 bg-light rounded">
                    <div class="d-flex align-items-center">
                      <div class="status-icon text-success mr-3">
                        <feather-icon icon="CheckCircleIcon" size="20" />
                      </div>
                      <div>
                        <div class="font-weight-medium text-dark">Vídeo carregado</div>
                        <small class="text-muted">
                          {{ getVideoFileName(config.videoKeyName) }}
                        </small>
                      </div>
                    </div>
                    <b-button 
                      size="sm" 
                      variant="outline-primary"
                      @click="showChangeVideo = true"
                    >
                      Trocar
                    </b-button>
                  </div>
                </div>

                <!-- Upload de vídeo - versão simplificada -->
                <div v-if="!config.videoUrl || showChangeVideo">
                  <b-form-file
                    ref="videoFileInput"
                    v-model="config.videoFile"
                    accept="video/*"
                    placeholder="Selecionar vídeo..."
                    drop-placeholder="Solte o vídeo aqui"
                    :required="!config.videoUrl"
                    class="mb-2"
                  />
                  
                  <!-- Botão cancelar (só aparece se estiver trocando) -->
                  <div v-if="config.videoUrl && showChangeVideo" class="text-right">
                    <b-button
                      size="sm"
                      variant="link"
                      @click="cancelChangeVideo"
                      class="p-0"
                    >
                      Cancelar
                    </b-button>
                  </div>
                </div>

                <!-- Barra de progresso mais limpa -->
                <div v-if="uploading" class="upload-progress mt-3">
                  <div class="d-flex justify-content-between mb-1">
                    <small class="text-muted">Enviando...</small>
                    <small class="text-primary font-weight-medium">{{ uploadPercentage }}%</small>
                  </div>
                  <b-progress
                    :value="uploadPercentage"
                    height="6px"
                    variant="primary"
                    striped
                    animated
                  />
                </div>
              </b-form-group>

              <!-- <b-form-group label="Qualidade:">
                <b-form-select
                  v-model="config.quality"
                  :options="qualityOptions"
                />
              </b-form-group> -->
              
              <!-- <b-form-group label="Bitrate (kbps):">
                <b-form-input
                  v-model.number="config.bitrate"
                  type="number"
                  min="1000"
                  max="13000"
                  step="500"
                />
              </b-form-group> -->
              
              <!-- <b-form-group label="FPS:">
                <b-form-select
                  v-model="config.fps"
                  :options="fpsOptions"
                />
              </b-form-group> -->

              <!-- <hr class="my-4">

              <h6 class="text-primary mb-3">
                <feather-icon icon="MessageSquareIcon" class="mr-1" />
                IA para Chat
              </h6> -->

              <!-- <b-form-group>
                <b-form-checkbox
                  v-model="config.aiChatEnabled"
                  size="lg"
                  switch
                >
                  <span class="font-weight-medium">Ativar IA para responder mensagens no chat</span>
                </b-form-checkbox>
                <small class="text-muted">
                  Quando ativado, a IA responderá automaticamente mensagens do chat baseado na palavra-chave configurada
                </small>
              </b-form-group> -->

              <!-- <b-form-group 
                v-if="config.aiChatEnabled"
                label="Palavra-chave para ativar a IA:"
                :state="aiKeywordState"
                invalid-feedback="A palavra-chave é obrigatória e deve começar com '!'"
              >
                <b-form-input
                  v-model="config.aiKeyword"
                  :state="aiKeywordState"
                  placeholder="Ex: !pergunta, !responda"
                  @input="onKeywordInput"
                  required
                />
                <small class="text-muted">
                  A palavra-chave deve começar com <b>!</b> (ex: <b>!pergunta</b>). Obrigatório quando IA está ativada.
                </small>
              </b-form-group> -->
              
              <b-button type="submit" variant="primary" block>
                <feather-icon icon="SaveIcon" class="mr-1" />
                Salvar Configuração
              </b-button>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
      
      <b-col md="6">
        <b-card>
          <b-card-header>
            <h5 class="mb-0">
              <feather-icon icon="InfoIcon" class="mr-2" />
              Informações da Configuração
            </h5>
          </b-card-header>
          
          <b-card-body>
            <div class="config-info">
              <div class="info-item">
                <span class="info-label">Título:</span>
                <span class="info-value">
                  {{ config.title || 'Não informado' }}
                </span>
              </div>
              
              <div class="info-item">
                <span class="info-label">Descrição:</span>
                <span class="info-value">
                  {{ config.description ? (config.description.length > 50 ? config.description.substring(0, 50) + '...' : config.description) : 'Não informada' }}
                </span>
              </div>
              
              <!-- <div class="info-item">
                <span class="info-label">Início Agendado:</span>
                <span class="info-value">
                  {{ config.scheduledStartTime ? new Date(config.scheduledStartTime).toLocaleString() : 'Não agendado' }}
                </span>
              </div>
              
              <div class="info-item">
                <span class="info-label">Privacidade:</span>
                <span class="info-value">{{ getPrivacyLabel(config.privacy) }}</span>
              </div>
              
              <div class="info-item">
                <span class="info-label">Thumbnail:</span>
                <span class="info-value">
                  {{ config.thumbnailFile ? config.thumbnailFile.name : 'Não selecionada' }}
                </span>
              </div> -->
              
              <hr>
              
              <div class="info-item">
                <span class="info-label">Stream Key:</span>
                <span class="info-value">
                  {{ config.streamKey ? 'Configurada' : 'Não configurada' }}
                </span>
              </div>
              
              <!-- <div class="info-item">
                <span class="info-label">Vídeos:</span>
                <span class="info-value">
                  {{ config.videoFiles.length > 0 ? `${config.videoFiles.length} arquivo(s) selecionado(s)` : 'Nenhum arquivo selecionado' }}
                </span>
              </div> -->

              <div class="info-item">
                <span class="info-label">Vídeo:</span>
                <span class="info-value">
                  <span v-if="config.videoUrl" class="text-success">
                    <feather-icon icon="CheckIcon" size="14" />
                    Enviado
                  </span>
                  <span v-else-if="config.videoFile" class="text-warning">
                    <feather-icon icon="ClockIcon" size="14" />
                    Aguardando envio
                  </span>
                  <span v-else class="text-muted">
                    Não selecionado
                  </span>
                </span>
              </div>

              <!-- Detalhes do vídeo selecionado -->
              <div
                v-if="config.videoUrl || config.videoFile"
                class="video-details-section"
              >
                <hr class="my-3">
                <h6 class="mb-3">
                  <feather-icon
                    icon="VideoIcon"
                    size="16"
                    class="mr-1"
                  />
                  Vídeo Selecionado
                </h6>
                
                <div class="video-info-card">
                  <!-- Vídeo já enviado -->
                  <div
                    v-if="config.videoUrl"
                    class="video-item uploaded"
                  >
                    <div class="video-icon">
                      <feather-icon
                        icon="PlayCircleIcon"
                        size="24"
                        class="text-success"
                      />
                    </div>
                    <div class="video-details">
                      <div class="video-name">
                        {{ getVideoFileName(config.videoKeyName) }}
                      </div>
                      <div class="video-status">
                        <span class="status-badge success">
                          <feather-icon
                            icon="CloudIcon"
                            size="12"
                          />
                          Disponível na nuvem
                        </span>
                      </div>
                      <div class="video-actions">
                        <small class="text-muted">Pronto para transmissão</small>
                      </div>
                    </div>
                  </div>

                  <!-- Prévia do vídeo -->
                  <div
                    v-if="config.videoUrl"
                    class="video-preview mt-3"
                  >
                    <div class="preview-header mb-2">
                      <small class="text-muted">
                        <feather-icon
                          icon="EyeIcon"
                          size="14"
                          class="mr-1"
                        />
                        Prévia do Vídeo
                      </small>
                    </div>
                    <div class="video-player-container">
                      <video
                        :src="config.videoUrl"
                        controls
                        preload="metadata"
                        class="video-preview-player"
                        @loadedmetadata="onVideoMetadataLoaded"
                      >
                        Seu navegador não suporta o elemento de vídeo.
                      </video>
                    </div>
                    <div class="video-info mt-2">
                      <small class="text-muted">
                        <span v-if="videoDuration">
                          Duração: {{ formatVideoDuration(videoDuration) }}
                        </span>
                        <span v-if="videoDimensions && videoDuration"> • </span>
                        <span v-if="videoDimensions">
                          Resolução: {{ videoDimensions }}
                        </span>
                      </small>
                    </div>
                  </div>

                  <!-- Vídeo local aguardando envio -->
                  <div
                    v-else-if="config.videoFile"
                    class="video-item pending"
                  >
                    <div class="video-icon">
                      <feather-icon
                        icon="HardDriveIcon"
                        size="24"
                        class="text-warning"
                      />
                    </div>
                    <div class="video-details">
                      <div class="video-name">
                        {{ config.videoFile.name }}
                      </div>
                      <div class="video-status">
                        <span class="status-badge warning">
                          <feather-icon
                            icon="ClockIcon"
                            size="12"
                          />
                          Aguardando envio
                        </span>
                      </div>
                      <div class="video-meta">
                        <small class="text-muted">{{ formatFileSize(config.videoFile.size) }}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Lista resumida dos vídeos -->
              <!-- <div v-if="config.videoFiles.length > 0" class="info-item">
                <span class="info-label">Arquivos:</span>
                <div class="info-value">
                  <div 
                    v-for="(video, index) in config.videoFiles.slice(0, 3)" 
                    :key="index"
                    class="video-summary-item"
                  >
                    <small>{{ video.name }} ({{ formatFileSize(video.size) }})</small>
                  </div>
                  <small v-if="config.videoFiles.length > 3" class="text-muted">
                    ... e mais {{ config.videoFiles.length - 3 }} arquivo(s)
                  </small>
                </div>
              </div> -->
              
              <!-- <div class="info-item">
                <span class="info-label">Qualidade:</span>
                <span class="info-value">{{ config.quality }}</span>
              </div>
              
              <div class="info-item">
                <span class="info-label">Bitrate:</span>
                <span class="info-value">{{ config.bitrate }} kbps</span>
              </div>
              
              <div class="info-item">
                <span class="info-label">FPS:</span>
                <span class="info-value">{{ config.fps }}</span>
              </div> -->

              <!-- <hr>

              <div class="info-item">
                <span class="info-label">IA no Chat:</span>
                <span class="info-value">
                  {{ config.aiChatEnabled ? 'Ativada' : 'Desativada' }}
                </span>
              </div> -->

              <!-- <div v-if="config.aiChatEnabled" class="info-item">
                <span class="info-label">Palavra-chave IA:</span>
                <span class="info-value">
                  {{ config.aiKeyword || 'Deve ser informada' }}
                </span>
              </div> -->
            </div>
            
            <!-- <hr> -->
            
            <!-- <div class="quality-guide">
              <h6>Guia de Qualidade:</h6>
              <ul class="list-unstyled">
                <li><strong>720p:</strong> 1280x720 - 1500-4000 kbps</li>
                <li><strong>1080p:</strong> 1920x1080 - 3000-6000 kbps</li>
                <li><strong>1440p:</strong> 2560x1440 - 6000-13000 kbps</li>
              </ul>
            </div> -->
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { 
  BCard, 
  BCardHeader, 
  BCardBody, 
  BForm, 
  BFormGroup, 
  BFormInput, 
  BFormSelect, 
  BFormFile, 
  BFormTextarea, 
  BFormCheckbox,
  BButton, 
  BRow, 
  BCol,
  BProgress,
  // BModal,
} from 'bootstrap-vue'
import { youtubeService } from '@/services/WebinarSimulator/youtubeService'
import { useApiAWS } from '@/composables/useApi'
import axios from 'axios'

const apiAws = useApiAWS()

export default {
  name: 'StreamConfig',
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormFile,
    BFormTextarea,
    BFormCheckbox,
    BButton,
    BRow,
    BCol,
    BProgress,
    // BModal,
  },
  props: {
    isAuthenticated: {
      type: Boolean,
      default: false,
    },
    webinarioData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      config: {
        // Dados da transmissão
        title: '',
        description: '',
        scheduledStartTime: '',
        privacy: 'unlisted',
        thumbnailFile: null,
        thumbnailUrl: '',
        // Configurações técnicas
        streamKey: '',
        videoFile: null, // Mantendo para compatibilidade
        videoUrl: '', // URL do vídeo no AWS
        videoKeyName: '', // Chave do arquivo no AWS
        // videoFiles: [], // Novo array para múltiplos vídeos
        quality: '1080p',
        bitrate: 3000,
        fps: 30,
        // Configurações da IA para chat
        aiChatEnabled: false,
        aiKeyword: '',
      },
      // Controle do upload
      uploading: false,
      uploadPercentage: 0,
      uploadNotification: null,
      showChangeVideo: false,
      // Informações do vídeo
      videoDuration: 0,
      videoDimensions: '',
      // Variáveis de ambiente
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3,
      userData: JSON.parse(localStorage.getItem('userData')),
      // Controle do modal
      // showVideoModal: false,
      // tempVideoFile: null,
      qualityOptions: [
        { value: '720p', text: '720p (HD)' },
        { value: '1080p', text: '1080p (Full HD)' },
        { value: '1440p', text: '1440p (2K)' },
      ],
      fpsOptions: [
        { value: 24, text: '24 FPS' },
        { value: 30, text: '30 FPS' },
        { value: 60, text: '60 FPS' },
      ],
      privacyOptions: [
        { value: 'public', text: 'Público' },
        { value: 'unlisted', text: 'Não listado' },
        { value: 'private', text: 'Privado' },
      ],
      aiKeywordState: null,
    }
  },
  watch: {
    uploadPercentage(newValue) {
      if (this.uploadNotification) {
        this.uploadNotification.message = `<div class="container">
          <strong>Fazendo upload <i>${newValue}%</i></strong>
          <div class="progress">
            <div class="progress-bar" style="width:${newValue}%">${newValue}%</div>
          </div>
        </div>`
      }
    },
    webinarioData: {
      handler(newWebinario) {
        if (newWebinario) {
          this.loadWebinarioToForm(newWebinario)
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.loadConfig()
  },
  methods: {
    // Métodos existentes
    onKeywordInput() {
      if (!this.config.aiChatEnabled) {
        this.aiKeywordState = null
        return
      }
      if (this.config.aiKeyword && this.config.aiKeyword.startsWith('!')) {
        this.aiKeywordState = true
      } else {
        this.aiKeywordState = false
      }
    },
    loadConfig() {
      const saved = localStorage.getItem('stream_config')
      if (saved) {
        const savedConfig = JSON.parse(saved)
        console.log('StreamConfig - Carregando configuração:', savedConfig)
        
        // Merge com a configuração atual, mas sempre mantém videoFile como null
        this.config = { 
          ...this.config, 
          ...savedConfig,
          videoFile: null // videoFile não pode ser persistido
        }
        
        console.log('StreamConfig - Configuração aplicada:', this.config)
      }
    },
    loadWebinarioToForm(webinario) {
      console.log('StreamConfig - Carregando webinário no formulário:', webinario)
      
      // Preenche os campos do formulário com os dados do webinário
      this.config = {
        ...this.config,
        title: webinario.titulo || '',
        description: webinario.descricao || '',
        streamKey: webinario.stream_key || '',
        videoUrl: webinario.video_url || '',
        videoKeyName: webinario.video_key_name || '',
        quality: webinario.qualidade || '1080p',
        bitrate: parseInt(webinario.bitrate, 10) || 3000,
        fps: parseInt(webinario.fps, 10) || 30,
        aiChatEnabled: webinario.resposta_ia === 1,
        aiKeyword: webinario.palavra_chave || '',
      }
      
      // Atualiza o estado da validação da palavra-chave
      this.onKeywordInput()
      
      console.log('StreamConfig - Formulário preenchido:', this.config)
    },
    
    // Novos métodos para gerenciar vídeo
    getVideoFileName(keyName) {
      if (!keyName) return 'Arquivo enviado'
      // Extrai o nome do arquivo da chave do AWS
      const parts = keyName.split('/')
      return parts[parts.length - 1] || 'Arquivo enviado'
    },

    cancelChangeVideo() {
      this.showChangeVideo = false
      this.config.videoFile = null
      if (this.$refs.videoFileInput) {
        this.$refs.videoFileInput.reset()
      }
    },

    async deletarVideoAntigoAWS(videoKeyName) {
      if (!videoKeyName) {
        console.log('Nenhum vídeo antigo para deletar')
        return
      }

      try {
        console.log('Deletando vídeo antigo do AWS:', videoKeyName)
        await apiAws.delete('/remover-folder', {
          params: {
            folder_key_name: videoKeyName,
          },
        })
        console.log('Vídeo antigo removido do AWS com sucesso')
      } catch (error) {
        console.error('Erro ao deletar vídeo antigo do AWS:', error)
        // Não exibe erro para o usuário pois é uma operação em background
      }
    },

    // Novos métodos para upload AWS
    normalizeFileName(fileName) {
      // Remove acentos e caracteres especiais
      const normalized = fileName
        .normalize('NFD') // Decompõe caracteres acentuados
        .replace(/[\u0300-\u036f]/g, '') // Remove os acentos
        .replace(/[^a-zA-Z0-9._-]/g, '_') // Substitui caracteres especiais por underscore
        .replace(/\s+/g, '_') // Substitui espaços por underscore
        .replace(/_+/g, '_') // Remove underscores duplicados
        .toLowerCase() // Converte para minúsculas
      return normalized
    },

    openUploadNotification() {
      this.uploadNotification = this.$notify({
        title: 'Upload do Vídeo',
        dangerouslyUseHTMLString: true,
        message: `<div class="container">
          <strong>Fazendo upload <i>${this.uploadPercentage}%</i></strong>
          <div class="progress">
            <div class="progress-bar" style="width:${this.uploadPercentage}%">${this.uploadPercentage}%</div>
          </div>
        </div>`,
        position: 'bottom-right',
        duration: 0,
      })
    },

    closeUploadNotification() {
      if (this.uploadNotification) {
        this.uploadNotification.close()
        this.uploadNotification = null
      }
    },

    async uploadVideoToAWS(file) {
      if (!file) return null

      // Guarda a referência do vídeo antigo para deletar depois
      const oldVideoKeyName = this.config.videoKeyName

      this.uploading = true
      this.uploadPercentage = 0

      // Normaliza o nome do arquivo
      const originalFileName = file.name
      const fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.'))
      const fileNameWithoutExtension = originalFileName.substring(0, originalFileName.lastIndexOf('.'))
      const normalizedFileName = this.normalizeFileName(fileNameWithoutExtension) + fileExtension

      // Cria um novo arquivo com o nome normalizado
      const normalizedFile = new File([file], normalizedFileName, { type: file.type })

      // Define o caminho da pasta
      const caminhoPasta = `${this.userData.user_file_key}WebinarVideos/`

      const formData = new FormData()
      formData.append('video', normalizedFile)
      formData.append('caminho', caminhoPasta)
      formData.append('videoType', 'webinar')

      this.openUploadNotification()

      try {
        const response = await axios.post(
          `${this.VUE_APP_HOST_API_AWS_S3}/uploadVideos`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: progressEvent => {
              const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total)
              this.uploadPercentage = percentage
            },
          },
        )

        if (response.data.data.status === 201) {
          // Atualiza a configuração com os dados do vídeo
          this.config.videoUrl = response.data.data.fileUrl
          this.config.videoKeyName = response.data.data.key_filename

          // Deleta o vídeo antigo do AWS se existir
          if (oldVideoKeyName && oldVideoKeyName !== this.config.videoKeyName) {
            this.deletarVideoAntigoAWS(oldVideoKeyName)
          }

          this.$toast.success('Vídeo enviado com sucesso!')
          
          return {
            url: response.data.data.fileUrl,
            keyName: response.data.data.key_filename,
            duration: response.data.data.duration,
            durationFormatted: response.data.data.durationFormatted,
            fileName: response.data.data.fileNameOrigin,
          }
        }
        throw new Error('Erro no upload do vídeo')
      } catch (error) {
        console.error('Erro no upload:', error)
        this.$toast.error(`Erro no upload: ${error.message}`)
        throw error
      } finally {
        this.uploading = false
        this.closeUploadNotification()
      }
    },

    async saveConfig() {
      // Validação: precisa ter um vídeo (seja novo ou já enviado)
      if (!this.config.videoFile && !this.config.videoUrl) {
        this.$toast.error('Selecione um arquivo de vídeo!')
        return
      }

      // Validação IA
      if (this.config.aiChatEnabled) {
        if (!this.config.aiKeyword || !this.config.aiKeyword.startsWith('!')) {
          this.aiKeywordState = false
          this.$toast.error('A palavra-chave da IA é obrigatória e deve começar com \'!\' (ex: !pergunta)')
          return
        }
      }

      try {
        console.log('Iniciando processo de salvamento...', {
          hasVideoFile: !!this.config.videoFile,
          hasVideoUrl: !!this.config.videoUrl,
          showChangeVideo: this.showChangeVideo,
        })
        
        // 1. Faz upload do vídeo para AWS se necessário
        if (this.config.videoFile && (!this.config.videoUrl || this.showChangeVideo)) {
          this.$toast.info('Enviando vídeo para o servidor...')
          const uploadResult = await this.uploadVideoToAWS(this.config.videoFile)
          
          if (!uploadResult) {
            this.$toast.error('Falha no upload do vídeo')
            return
          }
          
          // Reset do estado de troca após upload bem-sucedido
          this.showChangeVideo = false
        }

        const userData = localStorage.getItem('userData')
        const userId = userData ? JSON.parse(userData).id : null

        // 2. Monta o payload para criar o webinário
        const payload = {
          user_id: userId,
          titulo: this.config.title,
          descricao: this.config.description,
          stream_key: this.config.streamKey,
          qualidade: this.config.quality,
          bitrate: this.config.bitrate,
          fps: this.config.fps,
          video_url: this.config.videoUrl,
          video_key_name: this.config.videoKeyName,
          ai_chat_enabled: this.config.aiChatEnabled,
          ai_keyword: this.config.aiKeyword,
        }

        // 3. Chama o serviço para criar o webinário
        await youtubeService.createWebinario(payload)
        
        // 4. Salva a configuração localmente (sem o videoFile que não pode ser serializado)
        const { videoFile, ...configToSave } = this.config
        localStorage.setItem('stream_config', JSON.stringify(configToSave))
        
        // 5. Emite eventos
        this.$emit('stream-ready', this.config)
        this.$emit('config-saved')

      } catch (error) {
        console.error('Erro ao salvar configuração:', error)
        this.$toast.error(`Erro ao salvar configuração: ${error.message || error}`)
      }
    },

    // Métodos existentes mantidos
    getPrivacyLabel(privacy) {
      const option = this.privacyOptions.find(opt => opt.value === privacy)
      return option ? option.text : privacy
    },

    closeVideoModal() {
      this.showVideoModal = false
      this.tempVideoFile = null
    },

    addVideoToList() {
      if (this.tempVideoFile) {
        // Verifica se o arquivo já existe na lista
        const exists = this.config.videoFiles.some(video => (
          video.name === this.tempVideoFile.name
          && video.size === this.tempVideoFile.size
        ))

        if (exists) {
          this.$toast.warning('Este arquivo já foi adicionado!')
          // Limpa o campo mesmo se for duplicado
          this.tempVideoFile = null
          if (this.$refs.videoFileInput) {
            this.$refs.videoFileInput.reset()
          }
          return
        }

        // Adiciona o arquivo à lista
        this.config.videoFiles.push(this.tempVideoFile)
        this.$toast.success(`Vídeo "${this.tempVideoFile.name}" adicionado com sucesso!`)
        
        // Limpa o campo de input
        this.tempVideoFile = null
        if (this.$refs.videoFileInput) {
          this.$refs.videoFileInput.reset()
        }
      }
    },

    removeVideo(index) {
      const removedVideo = this.config.videoFiles[index]
      this.config.videoFiles.splice(index, 1)
      this.$toast.info(`Vídeo "${removedVideo.name}" removido!`)
    },

    clearAllVideos() {
      this.config.videoFiles = []
      this.$toast.info('Todos os vídeos foram removidos!')
    },

    saveVideosAndClose() {
      this.closeVideoModal()
      this.$toast.success(`${this.config.videoFiles.length} vídeo(s) selecionado(s)!`)
    },

    // Métodos de utilidade
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return `${parseFloat((bytes / (k ** i)).toFixed(2))} ${sizes[i]}`
    },

    formatDate(timestamp) {
      return new Date(timestamp).toLocaleString('pt-BR')
    },

    formatVideoDuration(seconds) {
      const hours = Math.floor(seconds / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      const secs = Math.floor(seconds % 60)
      
      if (hours > 0) {
        return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
      }
      return `${minutes}:${secs.toString().padStart(2, '0')}`
    },

    onVideoMetadataLoaded(event) {
      const video = event.target
      this.videoDuration = video.duration
      this.videoDimensions = `${video.videoWidth}x${video.videoHeight}`
      console.log('Metadados do vídeo carregados:', {
        duration: this.videoDuration,
        dimensions: this.videoDimensions,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.stream-config {
  .uploaded-video-card {
    .status-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: rgba(40, 167, 69, 0.1);
    }
  }

  .upload-progress {
    .progress {
      border-radius: 10px;
      overflow: hidden;
    }
  }

  .config-info {
    .info-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.75rem;
      padding: 0.5rem 0;
      border-bottom: 1px solid rgba(0,0,0,0.05);
      
      &:last-child {
        border-bottom: none;
        margin-bottom: 0;
      }
      
      .info-label {
        font-weight: 500;
        color: #495057;
        min-width: 100px;
      }
      
      .info-value {
        color: #6c757d;
        text-align: right;
        
        .feather-icon {
          margin-right: 4px;
        }
      }
    }

    .video-details-section {
      h6 {
        color: #495057;
        font-weight: 600;
        display: flex;
        align-items: center;
      }

      .video-info-card {
        background: #f8f9fa;
        border-radius: 8px;
        padding: 1rem;
        border: 1px solid #e9ecef;

        .video-item {
          display: flex;
          align-items: center;
          gap: 1rem;

          .video-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 48px;
            height: 48px;
            border-radius: 8px;
            background: rgba(255, 255, 255, 0.8);
            border: 1px solid #e9ecef;
          }

          .video-details {
            flex: 1;

            .video-name {
              font-weight: 500;
              color: #212529;
              margin-bottom: 0.25rem;
              word-break: break-word;
            }

            .video-status {
              margin-bottom: 0.25rem;

              .status-badge {
                display: inline-flex;
                align-items: center;
                gap: 0.25rem;
                padding: 0.25rem 0.5rem;
                border-radius: 12px;
                font-size: 0.75rem;
                font-weight: 500;

                &.success {
                  background: rgba(40, 167, 69, 0.1);
                  color: #28a745;
                }

                &.warning {
                  background: rgba(255, 193, 7, 0.1);
                  color: #ffc107;
                }
              }
            }

            .video-meta,
            .video-actions {
              font-size: 0.875rem;
            }
          }

          &.uploaded {
            .video-icon {
              background: rgba(40, 167, 69, 0.1);
              border-color: rgba(40, 167, 69, 0.2);
            }
          }

          &.pending {
            .video-icon {
              background: rgba(255, 193, 7, 0.1);
              border-color: rgba(255, 193, 7, 0.2);
            }
          }
        }
      }
    }

    .video-preview {
      .preview-header {
        color: #6c757d;
        font-weight: 500;
        display: flex;
        align-items: center;
      }

      .video-player-container {
        position: relative;
        width: 100%;
        background: #000;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        .video-preview-player {
          width: 100%;
          height: auto;
          max-height: 200px;
          display: block;
          background: #000;
        }
      }

      .video-info {
        text-align: center;
        color: #6c757d;
      }
    }
  }
  
  .quality-guide {
    background-color: #f8f9fa;
    padding: 1rem;
    border-radius: 8px;
    margin-top: 1rem;
    
    h6 {
      margin-bottom: 0.75rem;
      color: #495057;
    }
    
    ul {
      margin-bottom: 0;
      
      li {
        margin-bottom: 0.5rem;
        font-size: 0.875rem;
        color: #6c757d;
        
        strong {
          color: #495057;
        }
      }
    }
  }
}
</style>